module.exports = __webpack_public_path__ + "media/hph-26-04_career-outcomes.03c3f54b.mp4";